/**
 * Read-only service summary labels shared between {@link ServiceDetail} (which
 * produced them originally) and {@link ServiceSettingsPanel} (DNKADM-0295), which
 * reuses them so there stays exactly one place each label is produced. Split into
 * this plain module (rather than exporting them from `ServiceDetail.tsx`) because a
 * `.tsx` file that exports both a component and plain functions breaks React Fast
 * Refresh (`react-refresh/only-export-components`).
 */
import type { V2Service } from '@/api/services';

/**
 * Read-only guest-policy summary (DNKAPI-0145): "Guests: not allowed" when guests are
 * off, else "Guests: allowed (unlimited)" for a `0` cap or "Guests: allowed (max N)".
 */
export function guestSummary(service: V2Service): string {
  if (!service.allowGuests) return 'Guests: not allowed';
  return service.maxGuests > 0
    ? `Guests: allowed (max ${service.maxGuests})`
    : 'Guests: allowed (unlimited)';
}

/**
 * Human read-only label for the payment-capture mode (DNKAPI-0271): the two known values
 * map to friendly text; an unknown future value renders verbatim (extensible enum).
 */
export function paymentModeSummary(mode: V2Service['paymentMode']): string {
  if (mode === 'charge') return 'Charge at booking';
  if (mode === 'card_on_file') return 'Card on file, no charge';
  return mode;
}
